import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Seo from './components/Seo';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import Presupuesto from './pages/Presupuesto';
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import AvisoLegal from './pages/AvisoLegal';
import Privacidad from './pages/Privacidad';
import MudanzasMostoles from './pages/MudanzasMostoles';
import MudanzasMadridCentro from './pages/MudanzasMadridCentro';
import MudanzasChamberi from './pages/MudanzasChamberi';
import MudanzasAlcorcon from './pages/MudanzasAlcorcon';
import MudanzasFuenlabrada from './pages/MudanzasFuenlabrada';
import MudanzasGetafe from './pages/MudanzasGetafe';
import MudanzasLeganes from './pages/MudanzasLeganes';
import MudanzasSalamanca from './pages/MudanzasSalamanca';
import MudanzasRetiro from './pages/MudanzasRetiro';
import MudanzasTetuan from './pages/MudanzasTetuan';
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <Seo />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/presupuesto" element={<Presupuesto />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-privacidad" element={<Privacidad />} />
          <Route path="/mudanzas-mostoles" element={<MudanzasMostoles />} />
          <Route path="/mudanzas-madrid-centro" element={<MudanzasMadridCentro />} />
          <Route path="/mudanzas-chamberi" element={<MudanzasChamberi />} />
          <Route path="/mudanzas-alcorcon" element={<MudanzasAlcorcon />} />
          <Route path="/mudanzas-fuenlabrada" element={<MudanzasFuenlabrada />} />
          <Route path="/mudanzas-getafe" element={<MudanzasGetafe />} />
          <Route path="/mudanzas-leganes" element={<MudanzasLeganes />} />
          <Route path="/mudanzas-salamanca" element={<MudanzasSalamanca />} />
          <Route path="/mudanzas-retiro" element={<MudanzasRetiro />} />
          <Route path="/mudanzas-tetuan" element={<MudanzasTetuan />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
